import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
const forWhom = ['Madres con niños de 2 a 3 años que necesitan resultados rápidos.', 'Familias que quieren dejar de gastar $100+ al mes en pañales.', 'Padres que tienen una fecha límite para el ingreso al jardín de infancia.'];
const notForWhom = ['Personas que buscan una "pastilla mágica" sin dedicarle atención el fin de semana.', 'Niños menores de 18 meses (la madurez fisiológica es clave).'];
export function ForWhom() {
  return <section className="py-20 bg-cream-dark/50" data-id="element-82">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-83">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12" data-id="element-84">
          {/* For Whom */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border-t-4 border-teal" data-id="element-85">
            <h3 className="text-2xl md:text-3xl font-bold text-slate mb-8" data-id="element-86">
              Para quién SÍ es
            </h3>
            <ul className="space-y-6" data-id="element-87">
              {forWhom.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-88">
                  <CheckCircle2 className="text-teal flex-shrink-0 mt-1" size={24} data-id="element-89" />
                  <span className="text-slate-light text-lg" data-id="element-90">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For Whom */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white/60 p-8 md:p-10 rounded-3xl border border-slate-200" data-id="element-91">
            <h3 className="text-2xl md:text-3xl font-bold text-slate-light mb-8" data-id="element-92">
              Para quién NO es
            </h3>
            <ul className="space-y-6" data-id="element-93">
              {notForWhom.map((item, index) => <li key={index} className="flex items-start gap-4 opacity-80" data-id="element-94">
                  <XCircle className="text-slate-light flex-shrink-0 mt-1" size={24} data-id="element-95" />
                  <span className="text-slate-light text-lg" data-id="element-96">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}